async function formatPhoneNumber(phoneNumberString: string, country?: string): Promise<string> {
   const libphonenumber = await import("google-libphonenumber");
   const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();

   return formatPhoneNumberSync(phoneUtil, libphonenumber.PhoneNumberFormat.INTERNATIONAL, phoneNumberString, country);
}



export function formatPhoneNumberSync(phoneUtil: libphonenumber.PhoneNumberUtil, phoneNumberFormat: libphonenumber.PhoneNumberFormat, phoneNumberString: string, country?: string): string {
   const parseNumber = (c) => {
      if (!c)
         return undefined;

      try {
         const phoneNumber = phoneUtil.parse(phoneNumberString, c);
         const numberValid = phoneUtil.isValidNumberForRegion(phoneNumber, c);

         return {
            phoneNumber,
            numberValid
         }
      }
      catch {         
         return undefined;
      }
   }   

   let parseResult = parseNumber(country);
   if(!parseResult || !parseResult.numberValid)
      parseResult = parseNumber("US");

   if (!parseResult || !parseResult.numberValid) {
      const internationalNumberPrefix = "+";
      const phoneNumber = phoneNumberString.indexOf(internationalNumberPrefix, 0) == -1
         ? phoneUtil.parse(internationalNumberPrefix + phoneNumberString)
         : phoneUtil.parse(phoneNumberString);
      parseResult = {
         phoneNumber: phoneNumber,
         numberValid: true
      };
   }
   return phoneUtil.format(parseResult.phoneNumber, phoneNumberFormat);
}

type PhoneNumberType = string | undefined;

export function removeFormatPhoneNumber(value: PhoneNumberType): PhoneNumberType {
   if (value)
      return value.replace(/[^0-9]/g, "");
   return value;
}

export default formatPhoneNumber;